export default __webpack_public_path__ + "static/media/Guru-Parampara-27.98c3f8df.png";